import { http } from "../lib/axios";

const BASE_URL = '';

export const login = (username, password) => {
    const params = new URLSearchParams();
    params.append('grant_type', 'password');
    params.append('username', username);
    params.append('password', password);
    params.append('client_id', '2hbXY6q9DQ9xsy6afajvGouDu1RfVGRAPLl7oDuZ');
    params.append('client_secret', 'mysecret123');
  
    return http.post(`${BASE_URL}/o/token/`, params, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    });
  };  

export const register = (payload) => {
  const isFormData = (typeof FormData !== 'undefined') && payload instanceof FormData;
  return http.post('/api/accounts/register/', payload, {
    headers: isFormData ? { 'Content-Type': 'multipart/form-data' } : undefined,
  });
};

export const changePassword = (data, token) =>
  http.post(`${BASE_URL}/api/accounts/change-password/`, data, {
    headers: { Authorization: `Bearer ${token}` }
  });

export const requestPasswordReset = (email) =>
  http.post(`${BASE_URL}/api/accounts/reset-password/`, { email });

export const confirmResetPassword = (uid, token, new_password) =>
  http.post(`${BASE_URL}/api/accounts/reset-password/${uid}/${token}/`, { new_password });

